var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpuLimiterEnabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 61,
    viewBox: "0 0 58 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CPU Limiter_ON",
    clipPath: "url(#clip0_40_3369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5833 4.05V15.3L32.8333 15.3L32.8333 4.05L36.5833 4.05Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5833 45.3V56.55H32.8333L32.8333 45.3H36.5833Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.958252 28.425H17.8333V32.175H0.958252V28.425Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3333 28.425H57.2083V32.175H40.3333V28.425Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3333 4.05L25.3333 15.3L21.5833 15.3L21.5833 4.05L25.3333 4.05Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3333 45.3L25.3333 56.55H21.5833L21.5833 45.3H25.3333Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8333 11.55H10.3333V49.05H47.8333V11.55ZM6.58325 7.8V52.8H51.5833V7.8H6.58325Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3333 19.05H17.8333V41.55H40.3333V19.05ZM14.0833 15.3V45.3H44.0833V15.3H14.0833Z",
    fill: "#BCB3D0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_3369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.25,
    height: 60,
    fill: "white",
    transform: "translate(0.958252 0.299995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuLimiterEnabledMain);
export default __webpack_public_path__ + "static/media/cpuLimiterEnabledMain.1a8af93f18031116070c7de93a2694ae.svg";
export { ForwardRef as ReactComponent };